import React, { useState, forwardRef, useRef, useImperativeHandle} from 'react';
import { SliderComponent } from '@syncfusion/ej2-react-inputs';
import {AMModal, silenceLimitsArray} from '../../../ApiCenter/API_GET'
import './ManageLengths.css'
import '../../FileTransfer/ManageTargetAssets.css'




export const ManageSilences = forwardRef((props, ref) => {
    const defaultSettings = {
        showModal: false
    }

    const [modalSettings, setModalSettings] = useState(defaultSettings)
    const infoRef = useRef(null)
    
    const editable_headMinRef = useRef(null)
    const editable_headMaxRef = useRef(null)
    const editable_tailMinRef = useRef(null)
    const editable_tailMaxRef = useRef(null)

    useImperativeHandle(ref, () => ({
        openSilenceModal(props) {

            let values = props.rowData?.silence_limits;

            if(values){
                if(values?.active === undefined){
                    values.active =  true;
                }
                if(values?.skipSTC === undefined){
                    values.skipSTC =  false;
                }
            }

            const silenceSettings = values ?? {
                ...silenceLimitsArray(),
                active: false,
                skipSTC: false
            }
            infoRef.current = props

            setModalSettings({ 
                showModal: true,
                silence_limits: silenceSettings
            });
        }
    }));


    const closeModal = () => {
        setModalSettings(defaultSettings)
    }

    const handValue = (ref) => {
        if(ref.current.classList.contains('onEdit')) return;
        
        const input = document.createElement('input')
        input.type = 'text'
        input.value = ref.current.innerText
        input.classList.add('handValues')
        
        input.onblur = () => {
            const parent = ref.current.getAttribute('name');
            ref.current.innerText = validateValues(input.value, parent)
            input.remove()
            ref.current.classList.remove('onEdit')
        }
        
        input.onkeydown = (ev) => {
            if (ev.key === 'Enter') {
                ev.preventDefault()
                const parent = ref.current.getAttribute('name');
                ref.current.innerText = validateValues(input.value, parent)
                ref.current.classList.remove('onEdit')
            }
        }
        
        ref.current.innerHTML = ''
        ref.current.appendChild(input)
        ref.current.classList.add('onEdit')
        input.focus()
    }

    const validateValues = (value, useStateKey) => {
        let valueToCheck = value

        if(useStateKey === 'head_min'){valueToCheck = validateValue(value, 0, 0, modalSettings.silence_limits.head.max)}
        if(useStateKey === 'head_max'){valueToCheck = validateValue(value, 100, modalSettings.silence_limits.head.min, 5000)}
        if(useStateKey === 'tail_min'){valueToCheck = validateValue(value, 0, 0, modalSettings.silence_limits.tail.max)}
        if(useStateKey === 'tail_max'){valueToCheck = validateValue(value, 100, modalSettings.silence_limits.tail.min, 5000)}
        
        const [field, which] = useStateKey.split('_')
        setModalSettings(prev => ({
            ...prev,
            silence_limits: {
                ...prev.silence_limits,
                [field]: {
                    ...prev.silence_limits[field],
                    [which]: valueToCheck
                }
            }
        }))
        
        return valueToCheck
    }

    const validateValue = (value, alternative, min, max) => {
        let setValue = isNaN(parseFloat(value)) ? alternative : parseFloat(value)

        if (setValue < min) {
            setValue = min
        } else if (setValue > max) {
            setValue = max
        }

        return parseFloat(setValue.toFixed(1));
    }

    const handleSliderChange = (e, field) => {
        setModalSettings(prev => ({
            ...prev,
            silence_limits: {
                ...prev.silence_limits,
                [field]: {
                    min: e.value[0],
                    max: e.value[1]
                }
            }
        }))
    }

    const enableDisableOptions = (value, field) => {

        setModalSettings(prev => ({
            ...prev,
            silence_limits: {
                ...prev.silence_limits,
                [field]: value
            }
        }))
    }

    const applyData = () => {
        const settings = {
            silence_limits: modalSettings.silence_limits,
            reference: infoRef.current
        };
        if(props.onApplySilenceLimits) {
            props.onApplySilenceLimits(settings);
        }
        setModalSettings({showModal: false});
    }

    return modalSettings.showModal && <AMModal
                settings={modalSettings}
                setSettings={setModalSettings}
                header_title="Audio Silence Detection Settings"
                size="lg"
                closeHandler={closeModal}
                buttons={<button style={{width: 100}} className="btn btn-primary btn-sm" onClick={applyData}>Apply</button>}
                >
                <div className="manageLengths">
                    {/* Head Silence Section */}
                    <div className="card mb-3">
                        <div className="card-body p-2">
                            <div className="form-check form-switch d-flex justify-content-between align-items-center ps-0">
                                <label className="form-check-label" htmlFor="silence_limits_enabled">Enable Detection</label>
                                <input className="form-check-input" type="checkbox" id="silence_limits_enabled" 
                                    checked={modalSettings?.silence_limits?.active}
                                    onChange={(e) => enableDisableOptions(e.target.checked, 'active')}/>
                            </div> 
                        </div>
                    </div>
                    {modalSettings?.silence_limits?.active && 
                    <><div className="card mb-3">
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className='mb-0'>Head Silence</h5>
                                    <small className='text-muted'>Set the acceptable silence range at the beginning of audio files (in milliseconds)</small>
                                </div>
                            </div>
                            <div className="row g-2 mt-2">
                                <div className="col-4">
                                    <div className='text-muted small mt-1'>
                                        <p>Files with head silence outside this range will be flagged.</p>
                                    </div>
                                </div>
                                <div className="col-8 px-5" style={{fontSize: '13px', paddingBottom: '0px'}}>
                                    <b>Range (
                                        <i className="bx bx-message-square-edit"></i>
                                        <span className="editableValue text-primary" 
                                            ref={editable_headMinRef}
                                            name="head_min"
                                            onDoubleClick={() => handValue(editable_headMinRef)}>
                                            {modalSettings.silence_limits.head.min}
                                        </span> - 
                                        <span className="editableValue text-primary" 
                                            ref={editable_headMaxRef}
                                            name="head_max"
                                            onDoubleClick={() => handValue(editable_headMaxRef)}>
                                            {modalSettings.silence_limits.head.max}
                                        </span> ms
                                    )</b>
                                    <SliderComponent
                                        min={0}
                                        max={5000}
                                        step={1}
                                        type="Range"
                                        showButtons={true}
                                        ticks={{
                                            placement: 'Before',
                                            largeStep: 500,
                                            smallStep: 100,
                                            showSmallTicks: true
                                        }}
                                        value={[modalSettings.silence_limits.head.min, modalSettings.silence_limits.head.max]}
                                        change={(e) => handleSliderChange(e, 'head')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-3">
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className='mb-0'>Tail Silence</h5>
                                    <small className='text-muted'>Set the acceptable silence range at the end of audio files (in milliseconds)</small>
                                </div>
                            </div>
                            <div className="row g-2 mt-2">
                                <div className="col-4">
                                    <div className='text-muted small mt-1'>
                                        <p>Files with tail silence outside this range will be flagged.</p>
                                    </div>
                                </div>
                                <div className="col-8 px-5" style={{fontSize: '13px', paddingBottom: '0px'}}>
                                    <b>Range (
                                        <i className="bx bx-message-square-edit"></i>
                                        <span className="editableValue text-primary" 
                                            ref={editable_tailMinRef}
                                            name="tail_min"
                                            onDoubleClick={() => handValue(editable_tailMinRef)}>
                                            {modalSettings.silence_limits.tail.min}
                                        </span> - 
                                        <span className="editableValue text-primary" 
                                            ref={editable_tailMaxRef}
                                            name="tail_max"
                                            onDoubleClick={() => handValue(editable_tailMaxRef)}>
                                            {modalSettings.silence_limits.tail.max}
                                        </span> ms
                                    )</b>
                                    <SliderComponent
                                        min={0}
                                        max={5000}
                                        step={1}
                                        type="Range"
                                        ticks={{
                                            placement: 'Before',
                                            largeStep: 500,
                                            smallStep: 100,
                                            showSmallTicks: true
                                        }}
                                        value={[modalSettings.silence_limits.tail.min, modalSettings.silence_limits.tail.max]}
                                        change={(e) => handleSliderChange(e, 'tail')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-1">
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className='mb-0'>LS-SS Constraints</h5>
                                    <small className='text-muted'>Skip LS and SS Constraints from the detection</small>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="skipSTC"
                                    onChange={(e) => enableDisableOptions(e.target.checked, 'skipSTC')}
                                    checked={modalSettings.silence_limits.skipSTC ?? null} />
                                    <label className="form-check-label" htmlFor="skipSTC">
                                        Skip LS-SS Contraints
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    }
                </div>
                </AMModal>

})


                

